export enum ElasticTypes {
  SET_SPAN_APM = 'setSpanApm',
  END_SPAN_APM = 'endSpanApm',
}
